module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "familiarize"
  }, [(_vm.title.length) ? _c('Title', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.$slots.default) ? _c('div', {
    staticClass: "familiarize__description"
  }, [_vm._t("default")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f44c2a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/itemsblock/components/familiarize/Familiarize.vue
// module id = 95398e12bf5c35dd75de
// module chunks = 89